import React, { Component } from 'react';
import Select from 'components/Select';

export class NumberOfGuestsSelect extends Component {
  handleBlur = () => {
    const { input } = this.props;
    const { onBlur, value } = input;

    onBlur && onBlur(value);
  };

  render() {
    const { input, id, newValue } = this.props;
    const { onChange, value } = input;

    return (
      <Select
        id={id}
        className="openUp"
        clearable={false}
        deleteRemoves={false}
        backspaceRemoves={false}
        value={newValue ? newValue : value}
        options={[
          { value: 1, label: 1 },
          { value: 2, label: 2 },
          { value: 3, label: 3 },
          { value: 4, label: 4 }
        ]}
        onBlur={this.handleBlur}
        onChange={onChange}
      />
    );
  }
}

export default NumberOfGuestsSelect;
